import { render, staticRenderFns } from "./OrderWords.vue?vue&type=template&id=9e2a42b0&scoped=true"
import script from "./OrderWords.vue?vue&type=script&lang=js"
export * from "./OrderWords.vue?vue&type=script&lang=js"
import style0 from "./OrderWords.vue?vue&type=style&index=0&id=9e2a42b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2a42b0",
  null
  
)

export default component.exports